import { all } from 'redux-saga/effects';

import { watchAuth } from 'redux/sagas/auth.sagas';
import { watchBlocks } from 'redux/sagas/blocks.sagas';
import { watchCategoryPrices } from 'redux/sagas/categoryPrices.sagas';
import { watchCementeries } from 'redux/sagas/cementeries.sagas';
import { watchContactSettings } from 'redux/sagas/contactSettings.sagas';
import { watchDivorces } from 'redux/sagas/divorces.sagas';
import { watchDeaths } from 'redux/sagas/deaths.sagas';
import { watchDocuments } from 'redux/sagas/documents.sagas';
import { watchDocumentsTypes } from 'redux/sagas/documentsTypes.sagas';
import { watchGraves } from 'redux/sagas/graves.sagas';
import { watchJewishness } from 'redux/sagas/jewishness.sagas';
import { watchSystemStatus } from 'redux/sagas/systemStatus.sagas';
import { watchMarriages } from 'redux/sagas/marriages.sagas';
import { watchMatzeva } from 'redux/sagas/matzeva.saga';
import { watchPermissions } from 'redux/sagas/permissions.sagas';
import { watchPersons } from 'redux/sagas/persons.sagas';
import { watchProcedures } from 'redux/sagas/procedures.sagas';
import { watchProceduresEmails } from 'redux/sagas/proceduresEmails.sagas';
import { watchRoles } from 'redux/sagas/roles.sagas';
import { watchReservations } from 'redux/sagas/reservations.sagas';
import { watchUsers } from 'redux/sagas/users.sagas';

export default function* rootSaga(): Generator {
  yield all([
    watchAuth(),
    watchBlocks(),
    watchCategoryPrices(),
    watchCementeries(),
    watchContactSettings(),
    watchDivorces(),
    watchDeaths(),
    watchDocuments(),
    watchDocumentsTypes(),
    watchJewishness(),
    watchSystemStatus(),
    watchMarriages(),
    watchMatzeva(),
    watchGraves(),
    watchPermissions(),
    watchPersons(),
    watchProcedures(),
    watchProceduresEmails(),
    watchRoles(),
    watchReservations(),
    watchUsers(),
  ]);
}
